import { HashRouter, Routes, Route } from "react-router-dom";
import { App } from './App';

export const AppRoutes = () =>
    <HashRouter>
        <Routes>
            <Route path={'/'} element={<App/>}>
                <Route index path={':name'} element={<App/>}/>
                <Route path={'*'} element={<App/>}/>
            </Route>
        </Routes>
    </HashRouter>